import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import AcademicYearsTable from '../../components/academicYears/AcademicYearsTable';

const AcademicYears = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AcademicYearsTable />
        </WrapperSection>
    );
};

export default AcademicYears;
